import { Link } from 'gatsby';
import React from 'react';
import { hasRichTextContent } from '../../../../utils/general/builder';

const buttonVariantClassMap = {
    primary: 'milan-btn milan-primary-btn',
    secondary: 'milan-btn milan-secondary-btn',
    cta: 'milan-btn milan-cta-btn',
    overlay: 'milan-btn milan-overlay-btn',
    black: 'milan-btn milan-black-btn',
};

export function DynamicHeroContent({
    typefaceLogo,
    logoImageAlt,
    heading,
    headingColor = 'milan-text-primary',
    disclaimerColor = 'milan-text-navy',
    disclaimerLinkText,
    disclaimerTextPromise,
    richTextContent,
    buttonLink,
    buttonLabel,
    buttonVariant = 'primary',
    setShowSignUpModal,
    footerText,
    footerTextColor = 'milan-text-primary',
    isButtonCentered = true,
    isDesktop = false,
}) {
    const buttonClassName = buttonVariantClassMap[buttonVariant] || buttonVariantClassMap.primary;
    const hasContent = hasRichTextContent(richTextContent);
    const buttonContainerClassName = isDesktop && !isButtonCentered ? 'my-4 text-start' : 'my-4 text-center';

    return (
        <div className="col">
            {/* only hide on md */}
            {typefaceLogo && (
                <figure className="pb-4 position-relative z-index-100 text-center d-none d-lg-block">
                    <img
                        id="graphic"
                        src={typefaceLogo}
                        alt={logoImageAlt}
                        className="img-fluid w-auto"
                        style={{ maxHeight: '250px' }}
                    />
                </figure>
            )}
            {heading && (
                <h1 className={`${headingColor} smalltitle text-center ${!hasContent ? 'pb-0' : ''}`}>{heading}</h1>
            )}
            {hasContent && (
                <div
                    className="text-start milan-text-primary milan-rich-text"
                    dangerouslySetInnerHTML={{ __html: richTextContent }}
                />
            )}
            {/* Button - Book My Consultation */}
            <div className={buttonContainerClassName}>
                <Link className={buttonClassName} to={buttonLink}>
                    {buttonLabel}
                </Link>
            </div>
            {/* Modal - Stay up to date section */}
            {(disclaimerLinkText || disclaimerTextPromise) && (
                <p className={`${disclaimerColor} mb-lg-0 milan-fp text-start`}>
                    {disclaimerLinkText && (
                        <>
                            <span
                                className="text-decoration-underline pointer"
                                onClick={() => setShowSignUpModal(true)}
                            >
                                <strong>{disclaimerLinkText}</strong>
                            </span>{' '}
                        </>
                    )}
                    {disclaimerTextPromise && <span>{disclaimerTextPromise}</span>}
                </p>
            )}
            {footerText && <p className={`${footerTextColor} mb-lg-0 mt-2 milan-fp text-start`}>{footerText}</p>}
        </div>
    );
}
